import { useEffect, useState } from "react"
import { debounce } from "lodash"
import styled, { css } from "styled-components"

import { ReactComponent as IconTableCross } from "assets/svg/icon-table-cross.svg"
import { ReactComponent as IconTableSearch } from "assets/svg/icon-table-search.svg"

import useUrlQueryParams from "hooks/useUrlQueryParams"

import styles from "./index.module.scss"

const TableSearchWrapper = styled.div<{ withLabel: boolean }>`
  display: inline-flex;
  color: #808080;
  cursor: pointer;

  ${({ withLabel }) =>
    withLabel &&
    css`
      width: 100%;
    `}

  svg {
    stroke: #808080;
    transition: 0.2s;
    margin-left: 2px;
  }
`

const SearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
`

interface Props {
  name?: string
  label?: string
}

export const TableSearch = ({ name, label }: Props) => {
  const [isActive, setActive] = useState(false)
  const [value, setValue] = useState("")
  const { urlQueryParams, setUrlQueryParams } = useUrlQueryParams()

  const onClear = () => {
    setValue("")
    if (name) {
      setUrlQueryParams({ [name]: null })
    }
    setActive(false)
  }

  const onInputChange = (value: string) => {
    if (name) {
      setUrlQueryParams({
        [name]: value,
      })
    }
  }

  useEffect(() => {
    if (name && urlQueryParams[name] && !value) {
      setValue(urlQueryParams[name])
      setActive(true)
    } else if (urlQueryParams && name && !Object.hasOwn(urlQueryParams, name)) {
      setValue("")
      setActive(false)
    }
  }, [urlQueryParams])

  const setDebaunceSearchValue = debounce(onInputChange, 500)

  return (
    <TableSearchWrapper withLabel={!!label} onClick={() => {}}>
      {isActive ? (
        <div className={styles.inputWrapper}>
          <input
            className={styles.inputSearch}
            placeholder="Search.."
            autoFocus
            defaultValue={value}
            onChange={event => setDebaunceSearchValue(event.currentTarget?.value)}
            name={name === "email" ? "emailField" : name}
          />
          <span className={styles.iconClear} onClick={onClear}>
            <IconTableCross />
          </span>
        </div>
      ) : (
        <SearchContainer>
          {label && <span className={styles.label}>{label}</span>}
          <span className={styles.iconSearch} onClick={() => setActive(true)}>
            <IconTableSearch />
          </span>
        </SearchContainer>
      )}
    </TableSearchWrapper>
  )
}
